module.exports = __webpack_public_path__ + "static/NightInTheWoods4-ddaa7a8f0169cc2ba6acf2ff3668707a.png";